module.exports = __webpack_public_path__ + "toBride2-we-g-g.297a0dc0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride2-we-g-g.jpg
// module id = U2uE
// module chunks = 0